import { Injectable, Inject } from '@angular/core';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { interval } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CheckForUpdateService {
  constructor(
    private swUpdate: SwUpdate,
    private snackBar: MatSnackBar,
    @Inject(DOCUMENT) private document: Document
  ) {
    if (swUpdate.isEnabled) {
      // Check for updates every 6 hours
      interval(6 * 60 * 60 * 1000).subscribe(() => {
        this.checkForUpdate();
      });

      // Subscribe to version updates
      this.swUpdate.versionUpdates.subscribe((event: VersionEvent) => {
        if (event.type === 'VERSION_READY') {
          // Show a snackbar with an action to open the update dialog
          const snackBarRef = this.snackBar.open(
            'A new version is available!',
            'Update now',
            { duration: 8000 }
          );

          snackBarRef.onAction().subscribe(() => {
            this.document.location.reload();
          });
        }
      });
    }
  }

  checkForUpdate(): Promise<boolean> {
    if (!this.swUpdate.isEnabled) {
      return Promise.resolve(false);
    }

    return this.swUpdate.checkForUpdate();
  }

  activateUpdate(): Promise<boolean> {
    if (!this.swUpdate.isEnabled) {
      return Promise.resolve(false);
    }

    return this.swUpdate.activateUpdate().then(() => {
      window.location.reload();
      return true;
    });
  }
}
